import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import { useStyles } from "components/request-document/components/Commons";
import VisaIssuanceSection from "components/request-document/components/VisaIssuanceSection";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function VisaIssuanceStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);

  const personalId = get(personalDetail, "personalID", "");

  useEffect(() => {
    dispatch(
      getMasterData({
        CountryConfig: true,
        countryEmbassy: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance } = values;

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: [],
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({
    visaissuance: yup.object().shape({
      countryId: yup.string().when("overseas", {
        is: true,
        then: yup.string().nullable().required("Country is required"),
        otherwise: yup.string().nullable(),
      }),
      cityId: yup.string().when("overseas", {
        is: true,
        then: yup.string().nullable().required("City is required"),
        otherwise: yup.string().nullable(),
      }),
      theImmigrationBureauID: yup.string().when("thailand", {
        is: true,
        then: yup
          .string()
          .nullable()
          .required("The Immigration bureau is required"),
        otherwise: yup.string().nullable(),
      }),
      // visaTypeId: yup.string().nullable().required("VisaType is required"),
      // visaExp: yup.string().nullable().required("Expiry date is required"),
    }),
  });
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      visaissuance: {
        visaInssuanceId: get(smartform, "visaissuance.visaInssuanceId", null),
        overseas: get(smartform, "visaissuance.overseas", true),
        countryId: get(smartform, "visaissuance.countryId", ""),
        cityId: get(smartform, "visaissuance.cityId", ""),
        thailand: get(smartform, "visaissuance.thailand", false),
        theImmigrationBureauID: get(
          smartform,
          "visaissuance.theImmigrationBureauID",
          null
        ),
        oneStopService: get(smartform, "visaissuance.oneStopService", false),
        eec: get(smartform, "visaissuance.eec", false),
        visaTypeId: get(smartform, "visaissuance.visaTypeId", ""),
        visaExp: get(smartform, "visaissuance.visaExp", ""),
      },
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “I”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <VisaIssuanceSection colSpan={4} formik={formik} />
          </Table>
        </TableContainer>

        <ButtonController
          onClickSaveDraft={() => {
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
